var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"bonds-wrap"}},[_c('h3',[_vm._v("Bonds")]),_c('SimpleList',{attrs:{"items":_vm.bonds},on:{"change":_vm.updateBonds}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }